<template>
<div class="chapter">
<div class="inner_page">
<h1 class="block_11" id="id_Toc146554277" style="margin-top: 200px;"><span class="text_2">Part One</span><span class="text_2" id="id_Toc144730962"><br class="calibre4"/>Derek</span></h1>
<p class="block_12" id="calibre_pb_4"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_003.vue?4d28d54a